<template>
	<div class="row mt-4 mb-4">
		<div class="col-sm-12">
			<div class="row">
				<div class="col-sm-1 pr-0">
					<label for="type"></label>
					<select id="type" class="form-control p-0 text-center" v-model="record.type" @change="updateContentPlaceholder">
						<option v-for="type in types" :key="type.code" :value="type.code">{{type.code}}</option>
					</select>
				</div>
				<div class="col-sm-3 pr-0">
					<label for="name"></label>
					<input type="text" id="name" name="name" v-model="record.name" placeholder="Name" class="form-control"/>
				</div>
				<div :class="{'col-sm-2': record.type === 'MX', 'col-sm-3' : record.type !== 'MX', 'pr-0': true}">
					<label for="ip"></label>
					<input type="text" id="ip" name="content" v-model="record.content" :placeholder="contentPlaceholder" class="form-control"/>
				</div>
				<div v-if="record.type === 'MX'" class="col-sm-1 pr-0">
					<label for="ip"></label>
					<input type="number" id="priority" name="content" v-model="record.priority" min="0" max="65535" placeholder="Priority" class="form-control"/>
				</div>
				<div class="col-sm-2 pr-0">
					<label for="ttl"></label>
					<select name="ttl" id="ttl" class="form-control" v-model="record.ttl">
						<option value="1">Automatic TTL</option>
						<option value="120">2 minutes</option>
						<option value="300">5 minutes</option>
						<option value="600">10 minutes</option>
						<option value="900">15 minutes</option>
						<option value="1800">30 minutes</option>
						<option value="3600">1 hour</option>
						<option value="7200">2 hours</option>
						<option value="18000">5 hours</option>
						<option value="43200">12 hours</option>
						<option value="86400">1 day</option>
					</select>
				</div>
				<div class="col-sm-1 pr-0">
					<label>
						Status
						<i class="fa fa-question-circle text-primary" data-toggle="tooltip" data-placement="top" title="Traffic status for this record will or will not flow through CloudFlare. Typically you will only want traffic following through CloudFlare for records that load actual website content."></i>
					</label>
					<div class="custom-control custom-checkbox mr-sm-2 text-center">
						<input type="checkbox" id="proxied" name="proxied" v-model="record.proxied" checked class="custom-control-input"/>
						<label class="custom-control-label" for="proxied"></label>
					</div>
				</div>
				<div class="col-sm-2">
					<button type="submit" @click="store" :disabled="loading" class="btn btn-outline-primary btn-round btn-sm pull-right mt-4">
						<div class="loader small_loader" v-if="loading && action === 'create'"></div>
						<span v-else>
							Add Record
						</span>
					</button>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	import swal from "sweetalert2";
	import _ from "lodash";
	import validateMethods from "../../../mixins/validateMethods";
	import refreshToken from "../../../mixins/refreshTokenMixin";

	function initialState() {
		return {
			errors: [],
			action: null,
			record: {
				type: "A",
				name: null,
				content: null,
				ttl: 1,
				priority: 10,
				proxied: false
			},
			contentPlaceholder: 'IPv4 address',
			types: [
				{
					name: 'IPv4 address',
					code: 'A'
				},
				{
					name: 'IPv6 address',
					code: 'AAAA'
				},
				{
					name: 'Domain Name',
					code: 'CNAME'
				},
				{
					name: 'Value',
					code: 'TXT'
				},
				{
					name: 'Value',
					code: 'MX'
				},
			]
		}
	}

	export default {
		name: "DnsCreate",
		props: ["loading", "account", 'isTenant'],
		mixins: [validateMethods, refreshToken],
		data: function () {
			return initialState();
		},
		methods: {
			updateContentPlaceholder(){
				this.types.map((item)=>{
					if(this.record.type === item.code){
						this.contentPlaceholder = item.name;
					}
				})
			},
			store() {
				this.action = 'create';
				if (this.loading) {
					return false;
				}
				this.errors = [];
				if (!this.record.name) {
					this.errors.push('Please fill DNS record name');
				}

				if (!this.record.content) {
					this.errors.push('Please fill DNS record content');
				}

				if (this.errors.length) {
					swal({
						title: "Error message!",
						html: this.errors.join('<br/>'),
						type: "error"
					});
					return false;
				}

				this.$emit('update-loading', true);
				this.record.ttl = parseInt(this.record.ttl);
        this.record.priority = parseInt(this.record.priority);
        let obj= {
          grant_type: "token",
          token: this.userToken,
          cloudflare_email: this.account.cloudflare.username,
          cloudflare_api_key: this.account.cloudflare.apiKey,
          cloudflare_zone: this.account.cloudflare.zone_id,
          data: this.record
        }
        if(this.isTenant){
          obj.isTenant = true
        }

				this.$http.post("dns/create", obj,)
					.then(() => {
						this.$emit('update-list');
						this.cancel();
						swal({
							title: "Message!",
							html: "You successfully create DNS record",
							type: "success",
							confirmButtonText: "OK!",
							confirmButtonColor: "#EE8057"
						});
                        this.action = null;
                        this.$emit('update-loading', false);
					})
					.catch((err) => {
					    const {response} = err;
						let responseMessage = response.data.message;
						if (response.status === 422) {
							responseMessage = _.map(response.data.errors, 'msg').join('. ')
						}else if(response.status === 401){
							responseMessage = "You need update token. Please Try Again!";
							this.refreshToken();
						}

						swal({
							title: "Something went wrong!",
							html: responseMessage,
							type: "error",
							confirmButtonText: "Try Again!",
							confirmButtonColor: "#EE8057"
						});
                        if(response.status !== 401) {
                            this.addLog({
                                name: this.user.firstName + " " + this.user.lastName,
                                message: "Error create DNS record. Message: " + responseMessage,
                                level: "danger"
                            });
                        }
                        this.action = null;
                        this.$emit('update-loading', false);
					});

			},

			cancel() {
				Object.assign(this.$data, initialState());
			}
		},
		mounted() {
			/* eslint-disable */
			$(function () {
				$('[data-toggle="tooltip"]').tooltip();
			});
			/* eslint-enable */
		},
		updated() {
			/* eslint-disable */
			$(function () {
				$('[data-toggle="tooltip"]').tooltip();
			});
			/* eslint-enable */
		}
	}
</script>